module.exports = __webpack_public_path__ + "static/media/Yae Miko.5efd9ad3.png";